// Lot 678 — politique UNIQUE de préchargement média (Reels suivants, premier Reel, story suivante).
// Objectif : garder le démarrage instantané des Reels / stories (le manifeste + 1er segment déjà en cache HTTP est ce qui
// donne l'effet « TikTok ») tout en ne coûtant RIEN là où ça pourrait nuire :
//   • garde-fou admin « Préchargement des vidéos » coupé → rien (pilotable à distance, sans mise à jour) ;
//   • lien 2G ou économiseur de données (réglage Yalola ou celui du téléphone) → rien : données du membre préservées ;
//   • téléphone à faible mémoire (≤ 2 Go annoncés par navigator.deviceMemory, Android) → seul le préchargement « léger »
//     (cache HTTP, aucun décodeur, aucun blob) reste permis ; les <video> détachés et blobs MP4 complets sont évités.
import { guardOn } from "@/lib/guards";
import { dataSaverActive } from "@/lib/mediaUrl";
import { isSlowNetwork } from "@/lib/videoSource";
import { lowMemoryDevice, LOW_MEMORY_GB } from "@/lib/liteProfile";  // lot 734 — détection centralisée (Android 2 Go, iPhone 3 Go…)

export { lowMemoryDevice, LOW_MEMORY_GB };

// Préchargement « léger » : manifeste HLS + 1er segment (ou une image) déposés dans le cache HTTP du navigateur.
export const prefetchAllowed = () => guardOn("media_prefetch") && !dataSaverActive() && !isSlowNetwork();

// Préchargement « lourd » : <video> détaché (MP4 brut) ou blob MP4 complet gardé en mémoire → interdit sur faible mémoire.
export const heavyPrefetchAllowed = () => prefetchAllowed() && !lowMemoryDevice();
